import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Supabase } from '../services/supabase';
import { Database } from '../services/database';
import { User } from '../models/database.types';
import { firstValueFrom } from 'rxjs';

export const appGuard: CanActivateFn = async () => {
  const supabase = inject(Supabase);
  const db = inject(Database);
  const router = inject(Router);

  try {
    // 1. Check: Session vorhanden?
    const { data: { session }, error: sessionError } = await supabase.getClient().auth.getSession();
    
    if (sessionError || !session) {
      await supabase.getClient().auth.signOut();
      router.navigate(['/auth/login']);
      return false;
    }

    // 2. Check: Onboarding abgeschlossen?
    const userId = session.user.id;
    let dbUser: User | null = null;
    
    try {
      dbUser = await firstValueFrom(db.getUserById(userId));
    } catch (err) {
      // 406 = User existiert nicht in DB
      const error = err as { status?: number; code?: string };
      if (error?.status === 406 || error?.code === 'PGRST116') {
        await supabase.getClient().auth.signOut();
        router.navigate(['/auth/login']);
        return false;
      }
      dbUser = null;
    }
    
    if (!dbUser || !dbUser.company_id) {
      router.navigate(['/auth/onboarding']);
      return false;
    }

    return true;
  } catch {
    await supabase.getClient().auth.signOut();
    router.navigate(['/auth/login']);
    return false;
  }
};
